import { GuestInviteStep } from 'components/invitationScreen/GuestInviteStep';
import { InvitationScreenLayout } from 'layout/inviteLayout';

export const GuestInviteScreen = () => {
	return (
		<InvitationScreenLayout>
			<GuestInviteStep />
		</InvitationScreenLayout>
	);
};
